import React from "react";

const InterviewList = (props) => (
  <section id="interviews">
    <div className="section_hexagon" />
    <div className="section_title">
      <p>INTERVIEWS</p>
      <h2>ソルパックで働く社員からのメッセージ</h2>
    </div>
    <div className="section_contents">
      <div className="interview_list">
        <ul className="interview_slick">
          <li>
            <a data-id="sk">
              <div className="visual">
                <img src="images/interviews/sk-main_01.jpg" alt=""/>
              </div>
              <p className="title">
                <strong>
                旅行業からITへ<br />新たなチャレンジ
                </strong>
              </p>
              <div className="box">
                <div className="name">
                  <h3>S.Kさん</h3>
                </div>
                <div className="day brackets">
                  <p className="year_txt">入社年</p>
                  <p className="year">2018</p>
                </div>
              </div>
              <div className="job">
                <p>BPO事業部</p>
              </div>
              <div className="btn">
                <p>read more</p>
              </div>
            </a>
          </li>
          <li>
            <a data-id="mw">
              <div className="visual">
                <img src="images/interviews/mw-main_01.jpg" alt=""/>
              </div>
              <p className="title">
                <strong>
                  SOLPACの一員という意識をもって働いています
                </strong>
              </p>
              <div className="box">
                <div className="name">
                  <h3>M.Wさん</h3>
                </div>
                <div className="day brackets">
                  <p className="year_txt">入社年</p>
                  <p className="year">2009</p>
                </div>
              </div>
              <div className="job">
                <p>ERP事業部</p>
              </div>
              <div className="btn">
                <p>read more</p>
              </div>
            </a>
          </li>
          <li>
            <a data-id="kn1">
              <div className="visual">
                <img src="images/interviews/kn-main_01.jpg" alt=""/>
              </div>
              <p className="title">
                <strong>
                  毎日スキルアップしている自分を感じています
                </strong>
              </p>
              <div className="box">
                <div className="name">
                  <h3>K.Nさん</h3>
                </div>
                <div className="day brackets">
                  <p className="year_txt">入社年</p>
                  <p className="year">2017</p>
                </div>
              </div>
              <div className="job">
                <p>コンサルティング事業部</p>
              </div>
              <div className="btn">
                <p>read more</p>
              </div>
            </a>
          </li>
          <li>
            <a data-id="hw">
              <div className="visual">
                <img src="images/interviews/hongou-main.jpg" alt=""/>
              </div>
              <p className="title">
                <strong>
                  決め手は失敗を恐れず<br />前向きに取り組める環境
                </strong>
              </p>
              <div className="box">
                <div className="name">
                  <h3>H.Wさん</h3>
                </div>
                <div className="day brackets">
                  <p className="year_txt">入社年</p>
                  <p className="year">2018</p>
                </div>
              </div>
              <div className="job">
                <p>BPO事業部</p>
              </div>
              <div className="btn">
                <p>read more</p>
              </div>
            </a>
          </li>
          <li>
            <a data-id="kn2">
              <div className="visual">
                <img src="images/interviews/kn2-main.jpg" alt=""/>
              </div>
              <p className="title">
                <strong>
                  前職の経験を活かしつつ<br />さらなるスキルアップを
                </strong>
              </p>
              <div className="box">
                <div className="name">
                  <h3>K.Nさん</h3>
                </div>
                <div className="day brackets">
                  <p className="year_txt">入社年</p>
                  <p className="year">2008</p>
                </div>
              </div>
              <div className="job">
                <p>サービスマネジメント事業部</p>
              </div>
              <div className="btn">
                <p>read more</p>
              </div>
            </a>
          </li>
          <li>
            <a data-id="yk">
              <div className="visual">
                <img src="images/interviews/yk-main_01.jpg" alt=""/>
              </div>
              <p className="title">
                <strong>
                  SOLPACの価値をさらに上げることに貢献したい
                </strong>
              </p>
              <div className="box">
                <div className="name">
                  <h3>Y.Kさん</h3>
                </div>
                <div className="day brackets">
                  <p className="year_txt">入社年</p>
                  <p className="year">2007</p>
                </div>
              </div>
              <div className="job">
                <p>ERP事業部</p>
              </div>
              <div className="btn">
                <p>read more</p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
)

export default class Interview extends React.PureComponent {

  componentDidMount() {
    setTimeout(() => {
      let list = document.querySelectorAll('#interviews .section_contents .interview_list ul li a')
      let i = 0
      for (const item of list) {
        item.addEventListener('click', this.props.toInterview, false)
        i++
      }
    }, 1000)
  }

  render() {
    return <InterviewList />
  }
}


// WEBPACK FOOTER //
// ./src/Home/Interviews.js